import { faCircleInfo, faExclamationTriangle, faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Container, Form, Row, Col, Alert, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../App";
import GoBackBtn from "../../../components/buttons/GoBackBtn";
import ClassCard from "../../../components/classes/ClassCard";
import StudentsAttendanceList from "../../../components/StudentsAttendanceList";
import { postMethod } from "../../../requests";
import $ from "jquery";

const CheckAttendance = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const { checkServerData, changeView, setAlerts, showView } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [alertValidation, setAlertValidation] = useState(null);
    const [studentsList, setStudentsList] = useState(null);
    const [loadingClassCard, setLoadingClassCard] = useState(true);
    const [classData, setClassData] = useState(showView.params.class);
    const [changedForm, setChangedForm] = useState(false);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        let signUpListCnt = 0;
        studentsList.signUpList.forEach((e, i) => {
            if (e.ua_status_code === "UNCHECKED") {
                $(`#signUpList${i}`).addClass("is-invalid");
                signUpListCnt++;
            }
        });
        if (signUpListCnt > 0) errors.push(t("error.unCheckedOnSignupList"));

        if (errors.length > 0) {
            setAlerts([
                {
                    variant: "danger",
                    message: (
                        <div>
                            <p>{t("appearedErrors")}:</p>
                            <p>
                                {errors.map((e, i) => (
                                    <span key={i}>
                                        {e}
                                        {i + 1 < errors.length ? <br /> : ""}
                                    </span>
                                ))}
                            </p>
                        </div>
                    ),
                },
            ]);
        } else {
            setAlerts([{ variant: "info", message: t("info.checkingInStudents") }]);
            setBlockForm(true);
            checkPresentStudents();
        }
    };

    const checkPresentStudents = async () => {
        const res = await postMethod("/check-present-students", { classID: classData.class_id, studentsList: studentsList });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "checkPresence" }]);
            changeView({ nav: "schedule", sub: "main", params: { moduleName: "ADMIN_APP" } });
        } else setBlockForm(false);
    };

    const checkClassValidationForAttendance = async () => {
        const res = await postMethod("/check-class-validation-for-attendance", { classID: classData.class_id });
        if (checkServerData(res)) {
            if (res.data.variant && res.data.code) setAlertValidation({ variant: res.data.variant, message: t(`${res.data.variant}.${res.data.code}`) });
            else {
                setStudentsList(res.data.list);
                setAlertValidation(null);
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        if (showView.params.changedData) setChangedForm(true);
        checkClassValidationForAttendance();
        updateClassData();
        // eslint-disable-next-line
    }, []);

    const updateClassData = async () => {
        const res = await postMethod("/get-class-data", { classID: classData.class_id });
        if (checkServerData(res)) {
            setClassData(res.data.class);
            setLoadingClassCard(false);
        }
    };

    return (
        <Fragment>
            <GoBackBtn />
            <Form onSubmit={checkValidation} autoComplete="off">
                <Container fluid="lg">
                    <Row>
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <h1 className="h5 d-inline-block m-0 pt-2">{t("schedule.checkAttendance")}</h1>
                            <Button className="float-end d-inline-block" variant="outline-primary" onClick={() => changeView({ nav: "classes", sub: "addUserToClass", params: { c: classData } })}>
                                <FontAwesomeIcon icon={faPlus} className="me-lg-2" />
                                <span className="d-none d-lg-inline">{t("users.addUserToThisClass")}</span>
                            </Button>
                        </Col>
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <input type="text" name="prevent-autofill" id="prevent-autofill" style={{ display: "none" }} autoComplete="off" />
                            <Row>
                                {loadingClassCard ? (
                                    <Col xs={12}>
                                        <p className="h6">
                                            {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                        </p>
                                    </Col>
                                ) : (
                                    <Col xs={12} lg={6} xxl={5}>
                                        <ClassCard c={classData} />
                                    </Col>
                                )}
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        {loading ? (
                            <Col>
                                <p className="h6">
                                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                </p>
                            </Col>
                        ) : alertValidation ? (
                            <Alert variant={alertValidation.variant}>
                                <FontAwesomeIcon icon={alertValidation.variant === "warning" ? faExclamationTriangle : faCircleInfo} className="me-2" />
                                {alertValidation.message}
                            </Alert>
                        ) : (
                            studentsList && (
                                <StudentsAttendanceList
                                    studentsList={studentsList}
                                    setStudentsList={setStudentsList}
                                    blockForm={blockForm}
                                    setBlockForm={setBlockForm}
                                    setChangedForm={setChangedForm}
                                    classSlots={classData.class_slots}
                                    classData={classData}
                                    reloadData={() => {
                                        setLoading(true);
                                        setLoadingClassCard(true);
                                        setTimeout(() => {
                                            checkClassValidationForAttendance();
                                        }, 150);
                                    }}
                                />
                            )
                        )}
                    </Row>
                    <Row className="sticky-bottom bg-light-primary" style={{ zIndex: 2 }}>
                        <Col xs={7}>
                            <Button variant="primary" className="px-4 mt-4 mb-4" type="submit" disabled={blockForm || !changedForm}>
                                {t("saveChanges")}
                            </Button>
                        </Col>
                        <Col xs={5} className="text-end">
                            <Button variant="outline-secondary" className="px-4 mt-4 mb-4" onClick={() => changeView({ nav: "schedule", sub: "main", params: { moduleName: "ADMIN_APP" } })}>
                                {t("cancel")}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Form>
        </Fragment>
    );
};

export default CheckAttendance;
